import { useState, useEffect } from 'react';
import { useTwilioAppState } from '../state/';

/*
 * This hook allows components to reliably use the 'mediaStreamTrack' property of
 * an AudioTrack or a VideoTrack. Whenever 'localTrack.restart(...)' is called, it
 * will replace the mediaStreamTrack property of the localTrack, but the localTrack
 * object will stay the same. Therefore this hook is needed in order for components
 * to rerender in response to the mediaStreamTrack changing.
 */
export default function useMediaStreamTrack(track) {
    const [mediaStreamTrack, setMediaStreamTrack] = useState(track && track.mediaStreamTrack ? track.mediaStreamTrack : null);
    const { _isMounted } = useTwilioAppState();
    useEffect(() => {
        if (_isMounted && _isMounted.current === true) {
            setMediaStreamTrack(track && track.mediaStreamTrack ? track.mediaStreamTrack : null);
            if (track) {
                const handleStarted = () => setMediaStreamTrack(track.mediaStreamTrack);
                track.on('started', handleStarted);
                return () => {
                    track.off('started', handleStarted);
                };
            }
        }
  }, [track, _isMounted]);

  return mediaStreamTrack;
}
